/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/member-ordering */
import { Component, OnInit, Input, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import { ItineraryService } from '../../../shared/itinerary.service';
import { ConfirmationModalComponent } from '../../../shared/modals/confirmation-modal/confirmation-modal.component';
import { DeleteTransferModalComponent, DeleteTransferModalAction } from '../../../shared/modals/delete-transfer-modal/delete-transfer-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from '../../../pages/com.usblick.common/auth/user.service';
import { RestService } from '../../../shared/rest.service';
import { setting } from '../../../../../setting';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from 'app/core/profiles/storeProfile';
import { selectPermissions } from 'app/core/profiles/profiles.selectors';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import CssFilterConverter from 'css-filter-converter';
import { openModalResult } from 'app/shared/modals/openModalResultFunction';
import { isWebSource } from 'app/shared/itinerary-source';
import { NavigationEnd, Router } from '@angular/router';
import { NotificationService } from 'app/shared/notifications/notification.service';
import { parkIncludesTicket, parkMealOf, parkTicketOf, parkTicketTitle } from 'app/shared/modals/modal-hotel/park-flow/park-display';
@Component({
  selector: 'usb-item-details',
  templateUrl: './item-details.component.html',
  styleUrls: ['./item-details.component.scss'],
  providers: [DatePipe],
})
export class ItemDetailsComponent implements OnInit {
  estrella: any = [1, 2, 3, 4, 5, 6];
  @Input() item: any;
  @Input() reservation: any;
  @Input() selected: boolean;
  @Input() status: string;
  @Input() itinerary: any;
  @Input() clientsSettingAppBooking: any;
  @Input() currencies: any[] = [];
  @Input() currencyAgency: any;
  @Input() index: number;
  @Output() delete = new EventEmitter<string>();
  @Output() cancel = new EventEmitter<string>();
  @Output() reSearch = new EventEmitter<any>();
  @Output() loadingCancel = new EventEmitter<any>();
  // Emitido tras emitir/anular (void) un vuelo: el item.flightState
  // (canEmit/canVoid/canCancel) cambia del lado del backend y acá no hay
  // forma de recalcularlo sin recargar — mismo mecanismo que usa
  // item-status para forzar un refresh completo tras una acción que
  // cambia el estado del producto (ver card-itinerary.component.ts).
  @Output() reloadItinerary = new EventEmitter<void>();
  @Input() modifications: boolean;
  more: boolean;
  elementRef: any;

  // El tooltip de políticas de cancelación usaba pura CSS :hover, que en varios lugares de la
  // app queda "trabado" (se demora en cerrar) según el navegador/dispositivo. Se controla acá
  // con Angular en vez de depender del :hover, para que el cierre sea siempre inmediato.
  public cancellationTooltipOpen = false;
  public addonsTooltipOpen = false;

  public imageAgencyVoucher: any;
  public categoryImage: any;
  public logoAgency: any;
  public colorNumberVoucher: any;
  public bookingURL: string;

  allItinerary: any;
  itineraryItems: any = [];
  itineraryClient: any = [];
  loaded = false;
  itineraryId: number;
  totalPointAdded = 0; // total puntos sumados en la reserva
  pointsAvailable = 0; // total puntos acumulados
  pointCategory: any = 0;
  itinerary$: Observable<any[]>;
  paxesNumber: any;
  itineraryID: any;
   nameClient: any;
   totNight = 0;
   itineraryAgent: any = [];
   public moduleProfile: any[] = [];

   clientData: any = {
    name: null,
    mail: null,
    phone: null
  };

  flightInfo: any = {
    thisdepartureDate: null,
    arrivalDate: null,
    airport: null,
    airline: null,
    flightNumber: null
  };

  paxList: any;
  destinations: any;
  voucherInfo: any;

  permissions$: Observable<string[]>;
  permissionsMap: { [key: string]: boolean } = {};

  bsModalRef?: BsModalRef;
  appLoading = true;
  isLoadingCancel = false; // Loader custom para operaciones de cancelación
    private filterCache = new Map<string, string>();
    itemRateClass = '';


  private _unsubscribeAll: Subject<any> = new Subject<any>();

 openTooltips: Set<number> = new Set(); // Usando índice
// En lugar de Set, usar un objeto o array que Angular detecte
disabledButtons: { [key: string]: boolean } = {};

// O usando un array con ChangeDetectorRef
disabledButtonsArray: string[] = [];

  constructor(
    private datePipe: DatePipe,
    private itineraryService: ItineraryService,
    public userService: UserService,
    public _restService: RestService,
    private store: Store<AppState>,
    private modalService: BsModalService,
    private notificationService: NotificationService,
    private ngxSpinner: NgxSpinnerService,
    public dialog: MatDialog,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    this.more = false;

    this.itineraryService.consultActiveItinerary(this.userService._agentID, false, this.itinerary?.id, 'item-details');
    this.getItineraryInfo();
    this.bookingURL = setting.apiBookingUrl;
  }

  ngOnInit() {
    // console.log(this.item)
    // para probar la cancelación corriendo.
    // if((this.item.category_id === 1 || this.item.category_id === 4)) {
    //   this.item.cancellation_policy[0].from = "2026-06-10";
    //   this.item.room.cancellationPolicy[0].from = "2026-06-10";
    // }


    this.permissions$ = this.store.select(selectPermissions);
    this.permissions$.subscribe(permissions => {
      this.permissionsMap = this.createPermissionsMap(permissions);
    });

    this.logoAgency =  this.clientsSettingAppBooking?.logo_path_one;
    this.imageAgencyVoucher = this.clientsSettingAppBooking?.clients_setting_global?.logo64;
    this.colorNumberVoucher = this.clientsSettingAppBooking?.clients_setting_global?.color_main_3;
    this.subscribeChangeRoutePerTootip();

    this.itemRateClass = this.getRateClass(this.item.category_id, this.item);

  }

    getRateClass(category: any, item: any): string {

    let rateClass = '';
    switch(category) {

      case 4: // PARQUES TEMATICOS (mismo formato que alojamiento)
      case 1:
        rateClass = item?.room?.rateClass;
        break;
      case 2:
        rateClass = item?.rateClass;
        break;
      case 6:
        rateClass = item?.rateClassId;
        break;
      case 8:
        rateClass = item?.pricing?.rateClass;
        break;
      case 9:
        rateClass = 'NR';
        break;
      case 10:
        rateClass = item.rateClass;
        break;
      case 3:
        rateClass = item.rateClass;
        break;

    }

    return rateClass;
  }





  subscribeChangeRoutePerTootip(): void {
    this.router.events.subscribe((event) => {
  if (event instanceof NavigationEnd) {
    // ✅ Cerrar tooltips al cambiar de ruta
    this.closeAllTooltips();
  }
});
  }

    /**
     * Cierra todos los tooltips abiertos
     */
  private closeAllTooltips(): void {
    // ✅ Eliminar todos los tooltips del DOM
    document.querySelectorAll('.custom-exception-tooltip').forEach(el => el.remove());

    // ✅ Limpiar estado de botones
    this.disabledButtons = {};
    this.disabledButtonsArray = [];
    this.cdr.detectChanges();
  }

  createPermissionsMap(permissions: any[]): { [key: string]: any } {
    const map: { [key: string]: any } = {};
    permissions.forEach((permission) => {
      map[permission.name] = permission;
    });
    return map;
  }


  getItineraryInfo() {

    this.itinerary$ = this.itineraryService.getItinerary$();
    // console.log(this.itinerary$)
    this.itinerary$
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe((data: any) => {
      if(Object.keys(data).length > 0) {
        if (data !== undefined ) {
          this.itineraryItems = data[0];
          this.itineraryID = data[0].id;
          this.itineraryClient = data[1];
          this.nameClient = data[1]?.first_name + ' ' + data[1]?.last_name;
          // this.totNight = this.getNights();
          const paxes = (this.itineraryItems.totalAdults + this.itineraryItems.totalChildren) - 1;
          this.paxesNumber = paxes > 0 ? 'x ' + paxes : '';
          // this.getPartialAndSavedItems();
        } else {
          this.itineraryItems = this.userService.itineraryActive[0];
          this.itineraryID = this.userService.itineraryActive[0].id;
          this.itineraryClient = this.userService.itineraryActive[1];
          const paxes = (this.itineraryItems.totalAdults + this.itineraryItems.totalChildren) - 1;
          this.paxesNumber = paxes > 0 ? 'x ' + paxes : '';
          // this.getPartialAndSavedItems();
        }

        // this.pointCategory = this.fidelityService.getCalculatePointsByCategory(this.itineraryItems.items);
        this.loaded = true;
        this.userService.totalNetReserved = localStorage.getItem('totalNetReserved');
        this.userService.totalReserved = localStorage.getItem('totalReserved');
        // this.totalTarifaNeta = this.itineraryItems.totalPriceByNetReserved;
        //this.totalTarifa  = this.itineraryItems.totalPriceByReserved;

        this.pointsAvailable += this.itineraryItems.totalBlickoins;
      }
      // console.log('item -->', this.itineraryItems);
    });
    // console.log(this.itineraryItems.items)
  }


  vouchersReservationPdf(id: number): void {

    this.itineraryService.voucherDownload(id, this.clientsSettingAppBooking?.id, 'only', 1, this.currencyAgency);

  }

  _more() {
    this.more = true;
  }
  getLocation(): string {
    let location;
    switch (this.item.categoryName) {
      case 'DISNEY':
        location = this.item.hotel.additionalInfo.location;
        break;
      case 'INSURANCE':
        location = this.item.destination.iata_code;
        break;

      case 'RENT-A-CAR':
        location = this.item.destination.iata_code;
        break;

      default:
        location = this.item.location;
        break;
    }
    return location;
  }
  getClxDate(date: any) {
    // return this.datePipe.transform(moment(date), 'MMM dd, yyyy');
    return this.datePipe.transform(date, 'MMM dd, yyyy');
  }
  stars() {
    const array = [];
    for (let index = 0; index < this.item.hotelAdditionalInfo?.starRating; index++) {
      array.push(index);
    }
    return array;
  }
  getClxFee(charge: any) {
    const _charge = Number.parseFloat(charge);
    const total = Number.parseFloat(this.reservation.resultReserve.additionalInfo.totalPrice);
    return charge ? (_charge * 100) / total : 0;
  }
  getDate(checkIn: boolean) {
    // return checkIn ? this.datePipe.transform(moment(this.reservation.resultReserve.dateIni), 'MMM dd, yyyy') :
    // this.datePipe.transform(moment(this.reservation.resultReserve.dateEnd), 'MMM dd, yyyy');
    return checkIn
      ? this.datePipe.transform(this.reservation.resultReserve.dateIni, 'MMM dd, yyyy')
      : this.datePipe.transform(this.reservation.resultReserve.dateEnd, 'MMM dd, yyyy');
  }
  // getNights() {
  //   return moment(this.reservation.resultReserve.dateEnd).diff(this.reservation.resultReserve.dateIni, "days");
  // }
  getImage(): string {
    let image;
    switch (this.item.categoryName) {
      case 'DISNEY':
        image = this.item.hotel.additionalInfo.images[0].image;
        break;
      default:
        image = 'assets/img/app/hotel_default.png';
        break;
    }
    return image;
  }

  desc() {
    const array = [];
    for (let index = 0; index < 4; index++) {
      array.push(this.item.benefits ? this.item.benefits[index] : this.item.productSpecification[index]);
    }
    return array;
  }

  getDescription(): string {
    let description;
    switch (this.item.categoryName) {
      case 'DISNEY':
        description = this.item.hotel.additionalInfo.description;
        break;
      default:
        description = this.item.description ? this.item.description : 'no hay nada';
        break;
    }
    return description;
  }

  removeItem() {
    let message = '';

    const verifiedReservationArr: any[] = this.verifiedReservationId(this.item);

    if ((this.item.status_id == 1) ||  (this.item.status_id == 5)) {
      message = 'Esta seguro de Eliminar el producto?';
    }
    if (this.item.status_id == 2) {
      if(verifiedReservationArr.length > 1) {
        message = 'Hay más productos con el mismo localizador ¿Está seguro de cancelar los productos?';
      } else {
        message = '¿Esta seguro de cancelar el producto?';
      }
    }

    const initialState: ModalOptions = {
      initialState: {
        title: this.item.status_id === 2 ? 'Cancelar' : 'Eliminar',
        message: message.replace('¿Esta seguro', '¿Esta seguro<br />').replace('¿Está seguro', '¿Está seguro<br />'),
        icon: 'assets/icons/itinerary-detail/04-01.svg'
      }
    };

    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
    const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
      if(result) {
        const paxesQty = {
            destination: this.item.destination?.iata_code,
            adults: Number(this.item.paxAdults),
            children: Number(this.item.paxChildren)
          };
          // En itinerarios de cotización offline `itinerary.destination` puede
          // venir vacío o ausente: se recorre de forma defensiva para que el
          // eliminar/cancelar no rompa.
          (this.userService.itineraryActive[0]?.['destination'] || []).forEach((destination: any) => {
              if(destination.iata_code === paxesQty.destination && destination.destination_info) {
                destination.destination_info.adults -= paxesQty.adults;
                destination.destination_info.childs -= paxesQty.children;
              }
          });
        if((this.item.status_id == 1)  ||  (this.item.status_id == 5) ) {
          this.deleteItem();
        }
        if (this.item.status_id == 2) {
          this.cancelReservation(verifiedReservationArr);
        }
      } else {

      }
      confirmSubscription.unsubscribe();
    });
  }

  verifiedReservationId(item): any[] {
    let matchReservationId: any[] = [];

    // El localizador de reserva es lo que define el "bloque" de productos a
    // cancelar. Sin localizador (productos cotizados a mano, ítems offline sin
    // reservar) no hay bloque: comparar `undefined === undefined` haría que
    // entrara TODO el itinerario, así que en ese caso sólo se incluye el
    // propio producto.
    const locator = item?.resultReserve?.providerReservationId
      || item?.resultReserve?.reservation?.providerReservationId;
    if (!locator) {
      return item ? [item] : [];
    }

    switch(item?.category_id) {
  case 4: // PARQUES TEMATICOS (mismo formato que alojamiento)
  case 1:
          matchReservationId = this.itinerary.items.filter(c => c.resultReserve?.providerReservationId === item?.resultReserve?.providerReservationId);
    break;
  case 2:
          matchReservationId = this.itinerary.items.filter(c => c.resultReserve?.providerReservationId === item?.resultReserve?.providerReservationId);
    break;
  case 6:
          matchReservationId = this.itinerary.items.filter(c => c.resultReserve?.providerReservationId === item?.resultReserve?.providerReservationId);
    break;
  case 8:
          matchReservationId = this.itinerary.items.filter(c => c.resultReserve?.providerReservationId === item?.resultReserve?.providerReservationId);
    break;
  case 10:
          matchReservationId = this.itinerary.items.filter(c => c.resultReserve?.reservation?.providerReservationId === item?.resultReserve?.reservation?.providerReservationId);
    break;
}
    return matchReservationId;
    // return matchReservationId && matchReservationId.length > 1;
  }

  deleteItem() {
    this.itineraryService.remove(this.item !== undefined ? this.item : this.item);
    setTimeout(() => {
      this.delete.emit(this.item.id);
     this.userService.updateProductsPrices(this.item.itinerary_id);
    }, 1000);
  }

  cancelReservation(products: any) {
    this.isLoadingCancel = true;
    this.loadingCancel.emit(false);
    this.ngxSpinner.hide();

    // Cancelar reserva requiere el localizador del proveedor. Un producto sin
    // reserva real (cotizado a mano, ítem offline no reservado) no se puede
    // cancelar contra el proveedor: se corta el flujo con un mensaje claro en
    // vez de mandar un PUT sin `reservationLocator`.
    if (!this.canCancelReservation(this.item)) {
      this.isLoadingCancel = false;
      this.loadingCancel.emit(false);
      this.ngxSpinner.hide();
      this.notificationService.info('Este producto no tiene una reserva asociada al proveedor, no se puede cancelar.');
      return;
    }

    const cancelData: any = {};
    const productsIdArr = (products || []).map(c => c.id);
    switch(this.item?.category_id) {
      case 4: // PARQUES TEMATICOS (mismo formato que alojamiento)
      case 1:
        cancelData['providerId'] = this.item?.providerId;
        cancelData['reservationLocator'] = this.item?.resultReserve?.providerReservationId;
        // multiRoomCancel === true: cancelar solo este room; false/undefined: cancelar todo el bloque
        cancelData['productsId'] = this.item?.resultReserve?.multiRoomCancel === true
          ? [this.item.id]
          : productsIdArr;
        break;
      case 2:
        cancelData['providerId'] = this.item?.providerId;
        cancelData['reservationLocator'] = this.item?.resultReserve?.providerReservationId;
        cancelData['productsId'] = productsIdArr;
        break;
      case 6:
        cancelData['providerId'] = this.item?.providerId;
        cancelData['reservationLocator'] = this.item?.resultReserve?.providerReservationId;
        cancelData['productsId'] = productsIdArr;
        break;
      case 8:
        cancelData['providerId'] = this.item?.providerId;
        cancelData['reservationLocator'] = this.item?.resultReserve?.providerReservationId;
        cancelData['productsId'] = productsIdArr;
        break;
      case 10:
        cancelData['providerId'] = this.item?.providerId;
        cancelData['reservationLocator'] = this.item?.resultReserve?.reservation?.providerReservationId;
        cancelData['productsId'] = productsIdArr;
        break;
      // case 9:
      //   cancelData['providerId'] = this.item?.providerId;
      //   cancelData['reservationLocator'] = this.item?.resultReserve?.providerReservationId;
      //   cancelData['productsId'] = productsIdArr;
      //   break;
  }

   this._restService.doPut('app', `products/cancelReservation/${this.item?.itinerary_id}`, cancelData).subscribe({
    next: (res: any) => {
      // console.log('response cancel', res);
      this.isLoadingCancel = false;
      this.loadingCancel.emit(false);
      this.ngxSpinner.hide();

      const item = this.itineraryService.itinerary.items.find(c => c.id === this.item.id);

      item.amount_convert_cancellation = this.getCancellationPolicies(item.category_id, item);
      item.pricing_convert_cancellation = this.getPriceConvertCancelation(item.category_id, item);

      this.itineraryService.itinerary.clientId = this.itineraryService.itinerary.client_id;

      this.itineraryService.updateItinerary(this.itineraryService.itinerary);

      this.notificationService.success('Su producto fue cancelado con éxito');

      this.cancel.emit(this.item.id);
    },
    error: (error: HttpErrorResponse) => {
      this.isLoadingCancel = false;
      this.loadingCancel.emit(false);
      this.ngxSpinner.hide();
      this.notificationService.error('Ocurrio un error');
      console.log(error);
    }
  });
  }

getCancellationPolicies(category, item) {
    const currentDate = new Date();
    const defaultPolicy = {
        currency: this.currencyAgency?.code,
        from: currentDate,
        amount: 0,
        apply: false
    };

    // Determinar el array de políticas según la categoría
    let policies = [];
    if (category === 1) {
        policies = item.room?.cancellationPolicy || [];
    } else if (category === 8) {
        policies = item.cancellationPolicies || [];
    }

    // Si no hay políticas, retornar el default
    if (policies.length === 0) {
        return [defaultPolicy];
    }

    // Ordenar políticas por fecha 'from'
    const sortedPolicies = [...policies].sort((a, b) =>
        new Date(a.from).getTime() - new Date(b.from).getTime()
    );

    // Encontrar la política aplicable
    let applicableIndex = -1;
    for (let i = 0; i < sortedPolicies.length; i++) {
        if (new Date(sortedPolicies[i].from) <= currentDate) {
            applicableIndex = i;
        } else {
            break;
        }
    }

    // Preparar el resultado con el campo apply
    const result = sortedPolicies.map((policy, index) => {
      const baseRate = this.currencies.find(c => c.code === policy.currency)?.rate || 1;
      const targetRate = this.currencyAgency?.rate || 1;

        const isApplicable = index === applicableIndex;
        const amountProf = (policy?.amountProf / baseRate) * targetRate;

        return {
            ...policy,
            currency: this.currencyAgency?.code,
            amountProf,
            amount: policy?.amount,
            apply: isApplicable
        };
    });

    // Si no hay ninguna aplicable y hay políticas, marcamos todas como no aplicables
    if (applicableIndex === -1 && result.length > 0) {
      const targetRate2 = this.currencyAgency?.rate || 1;
      return result.map(policy => ({
            ...policy,
            currency: this.currencyAgency?.code,
            amountProf: (policy.amountProf / this.currencies.find(c => c.code === policy.currency)?.rate) * targetRate2,
            amount: policy.amount,
            apply: false
        }));
    }

    return result;
}


getPriceConvertCancelation(category, item): any {

    const baseRate = this.currencies.find(c => c.code === item.currency);

    const itemFee = item.fee / baseRate.rate;
    const itemNetPriceAgent = item.netPriceAgent / baseRate.rate;
    const itemNetPriceBooking = item.netPriceBooking / baseRate.rate;
    const taxNightsPriceTotal = item.taxNightsPriceTotal / baseRate.rate;
    const netPriceBookingFreeTax = item.netPriceBookingFreeTax / baseRate.rate;
    const netPriceProvider = item.profility.netPriceProvider / baseRate.rate;
    const netPriceCategory = item.profility.netPriceCategory / baseRate.rate;

    return {
          exchange_rate: parseFloat(Number(this.currencyAgency.rate).toFixed(2)),
          converted_amounts: {
                    fee: parseFloat(Number(itemFee * this.currencyAgency.rate).toFixed(2)),
                    netPriceAgent: parseFloat(Number(itemNetPriceAgent * this.currencyAgency.rate).toFixed(2)),
                    netPriceBooking: parseFloat(Number(itemNetPriceBooking * this.currencyAgency.rate).toFixed(2)),
                    taxPrice: parseFloat(Number(taxNightsPriceTotal * this.currencyAgency.rate).toFixed(2)),
                    netPriceBookingFreeTax: parseFloat(Number(netPriceBookingFreeTax * this.currencyAgency.rate).toFixed(2)),
                    netPriceProvider: parseFloat(Number(netPriceProvider * this.currencyAgency.rate).toFixed(2)),
                    netPriceCategory: parseFloat(Number(netPriceCategory * this.currencyAgency.rate).toFixed(2)),
                    rate_timestamp: new Date(),

                }
           };
}


  copyToClipboard(value: string | undefined): void {
  if (!value) {
return;
}
  navigator.clipboard.writeText(value)
    .then(() => {
      this.notificationService.info(`Localizador copiado: ${value}`);
      // Podés agregar una notificación aquí si querés
    })
    .catch(err => {
      console.error('Error al copiar al portapapeles:', err);
    });
}


  stingUpperCase(str: any) {
    if (str) {
      const e = str.toLowerCase();
      return e.replace(/\b\w/g, (l) => l.toUpperCase());
    }
  }

  edit() {
    window.scrollTo(0, 0);
    // modo quoute
    // console.log('item', this.item);
    // if (this.item.status_id == 1) {


      let message = '';
      let pairedTransferItem: any;
      let singleTransferDateLabel = '';

      switch(this.item.category_id) {
        case 4: // PARQUES TEMATICOS (mismo formato que alojamiento)
        case 1:
          message = '¿Deseas eliminar este producto y buscar un nuevo hotel en ' +
          this.item.location +
          ' del ' +
          this.returnDate(this.item.arrivalDate) +
          ' hasta ' +
          this.returnDate(this.item.departureDate) +
          ' para ' +
          this.item.paxAdults +
          ' adultos?';
          break;
        case 2:
          message = '¿Deseas eliminar este producto y buscar un nuevo coche en ' +
          this.item.location +
          ' del ' +
          this.returnDate(this.item.arrivalDate) +
          ' hasta ' +
          this.returnDate(this.item.departureDate) +
          ' para ' +
          this.item.paxAdults +
          ' adultos?';
          break;
        case 6:
          let category: string;
          if(this.item.subCategoryId === 6) {
            category = 'una nueva experiencia';
          }
          if(this.item.subCategoryId === 9) {
            category = 'un nuevo ticket';
          }
          // Los ítems de cotización offline pueden no traer `form.destination`
          // (el backend no los puebla): se usa el location como fallback para
          // que el mensaje del modal siempre sea legible.
          const cityName = this.item.form?.destination?.city_name
            || this.item.location
            || '';
          message = `¿Deseas eliminar este producto y buscar ${category} en `+
          cityName +
          ' del ' +
          this.returnDate(this.item.arrivalDate) +
          ' hasta ' +
          this.returnDate(this.item.departureDate) +
          ' para ' +
          this.item.paxAdults +
          ' adultos?';
          break;
        case 8:


          const oneWay = this.item?.payload[0]?.transfers.oneWay;

          const arrival = this.item?.timing?.entry?.entryDepartureDatetime || this.item?.arrivalDate;
          const departure = this.item?.timing?.return?.returnDepartureDatetime || this.item.departureDate;


          if(!oneWay) {
            // Traslado ida y vuelta: busca el otro tramo (firstWay 1/2) con el mismo bookingCode
            pairedTransferItem = this.item?.firstWay
              ? this.itinerary?.items?.find((otherItem: any) =>
                  otherItem !== this.item &&
                  otherItem.category_id === 8 &&
                  otherItem.bookParam === this.item.bookParam &&
                  otherItem.firstWay === (this.item.firstWay === 1 ? 2 : 1) &&
                  otherItem.status_id === this.item.status_id &&
                  this.validDateUpdate(otherItem.arrivalDate)
                )
              : undefined;

            if (pairedTransferItem) {
              const idaItem = this.item.firstWay === 1 ? this.item : pairedTransferItem;
              const vueltaItem = this.item.firstWay === 1 ? pairedTransferItem : this.item;

              const idaDate = idaItem?.timing?.entry?.entryDepartureDatetime || idaItem?.arrivalDate;
              const vueltaDate = vueltaItem?.timing?.return?.returnDepartureDatetime || vueltaItem?.departureDate;

              message = '¿Deseas eliminar este producto y buscar un nuevo traslado del ' +
              this.formatDateSlash(idaDate) +
              ' hasta ' +
              this.formatDateSlash(vueltaDate) +
              ' para ' +
              this.item.paxAdults +
              ' adultos?';

              // Fecha propia de este tramo, por si se elige eliminar solo este y no el par
              const { date: ownDate, time: ownTime } = this.formatDateSlashWithTime(departure);
              singleTransferDateLabel = ownTime ? `${ownDate}, ${ownTime}` : ownDate;

              break;
            } else {
                const { date, time } = this.formatDateSlashWithTime(departure);
                message = '¿Deseas eliminar este producto y buscar un nuevo traslado para fecha ' +
                date +
                ', ' +
                time +
                ', para ' +
                this.item.paxAdults +
                ' adultos?';
            }

          } else {
                const { date, time } = this.formatDateSlashWithTime(departure);
                message = '¿Deseas eliminar este producto y buscar un nuevo traslado para fecha ' +
                date +
                ', ' +
                time +
                ', para ' +
                this.item.paxAdults +
                ' adultos?';

          }
          break;
        case 10:
          message = '¿Deseas eliminar este producto y buscar una nueva asistencia en ' +
          this.item.form.destination +
          ' del ' +
          this.returnDate(this.item.arrivalDate) +
          ' hasta ' +
          this.returnDate(this.item.departureDate) +
          ' para ' +
          this.item.paxAdults +
          ' adultos?';
          break;
      }


      const modalMessage = `<div class="px-4">${message.replace(/¿/g, '¿').replace(/\?/g, '?<br />')}</div>`;

      if (this.item.category_id === 8 && pairedTransferItem) {
        const initialState: ModalOptions = {
          initialState: {
            title: 'Eliminar',
            message: modalMessage,
            icon: 'assets/icons/itinerary-detail/04-01.svg',
            confirmText: 'Eliminar traslado',
            confirmSubText: singleTransferDateLabel
          }
        };

        this.bsModalRef = this.modalService.show(DeleteTransferModalComponent, initialState);
        const actionSubscription = (this.bsModalRef.content as DeleteTransferModalComponent).actionResult.subscribe(async (action: DeleteTransferModalAction) => {
          if (action === 'delete') {
            await this.reSearch.emit({item: this.item, action: 'delete'});
          } else if (action === 'deleteRoundTrip') {
            // El payload de this.item ya contiene el traslado ida y vuelta original,
            // por eso se reutiliza para la búsqueda; solo se agrega el tramo pareado
            // para que también se elimine del itinerario.
            await this.reSearch.emit({item: this.item, pairedItem: pairedTransferItem, action: 'deleteRoundTrip'});
          }
          actionSubscription.unsubscribe();
        });
        return;
      }

      const initialState: ModalOptions = {
        initialState: {
          title: 'Eliminar',
          message: modalMessage,
          icon: 'assets/icons/itinerary-detail/04-01.svg'
        }
      };

      this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
      const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe(async (result: boolean) => {
        if(result) {
          await this.reSearch.emit({item: this.item, action: 'delete'});
        } else {

        }
        confirmSubscription.unsubscribe();
      });
  }

  returnDate(date: any) {
    const dateSplit = date.split('-');
    return (
      '' +
      dateSplit[2] +
      '-' +
      moment()
        .locale('es')
        .month(parseInt(dateSplit[1]) - 1)
        .format('MMM')
    );
  }

  formatDateSlash(date: any): string {
    if (!date || typeof date !== 'string' || !date.includes('-')) {
return '';
}
    // Limpiar la hora si viene (formato "YYYY-MM-DD HH:mm")
    const dateOnly = date.split(' ')[0];
    const parts = dateOnly.split('-');
    if (parts.length !== 3) {
return '';
}
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  }

  /**
   * Versión que devuelve fecha + hora por separado.
   * Si no viene hora, devuelve time = null.
   * @returns
   */
  formatDateSlashWithTime(date: any): { date: string; time: string | null } {
    const result = { date: '', time: null as string | null };
    if (!date || typeof date !== 'string' || !date.includes('-')) {
return result;
}
    const [dateOnly, timeOnly] = date.split(' ');
    const parts = dateOnly.split('-');
    if (parts.length !== 3) {
return result;
}
    result.date = `${parts[2]}/${parts[1]}/${parts[0]}`;
    result.time = timeOnly ? timeOnly.substring(0, 5) : null; // HH:mm
    return result;
  }

  updateItem(item: any): void {
    this.reSearch.emit({item: this.item, action: 'add'});
  }

  // Ciudad + IATA de cada escala (todos los segmentos del tramo salvo el
  // último, cuyo arrival ya es el destino final, no una escala).
  getFlightStops(item: any): { city: string; airport: string }[] {
    const segments = item?.itinerary?.[0]?.options?.[0]?.segments || [];
    if (segments.length <= 1) {
      return [];
    }
    return segments.slice(0, -1).map((segment: any) => ({
      city: segment?.arrival?.city,
      airport: segment?.arrival?.airport,
    }));
  }

  // Valida por capas el nombre/info del pasajero para no generar errores.
  paxInfoValidate(item: any): boolean{
    const paxInfoValidate = item?.resultReserve?.additionalInfo.rooms;

    if (!Array.isArray(paxInfoValidate)) {
return false;
}
    if(paxInfoValidate.length === 0) {
return false;
}
    if(!paxInfoValidate[0]?.paxList) {
return false;
}

    return true;
  }

      extractNameTransport(form: any, type: string): string {
    switch(type) {
      case 'origin':
        const formTransportOrigin = form?.formTransport?.firstOrigin;
        switch(form.payload[0]?.transfers?.pickupLocation?.type) {
          case 'hotel':
            return `${formTransportOrigin?.name || formTransportOrigin?.hotel_name} (${formTransportOrigin?.iata || formTransportOrigin?.destination_code})`;
          case 'airport':
            return `${formTransportOrigin?.name} (${formTransportOrigin?.iata})`;
          case 'destination':
            return `${formTransportOrigin?.city_name} (${formTransportOrigin?.country_code})`;
          case 'city':
            return  `${formTransportOrigin?.display}`;
        }
      case 'destination':
        const formTransportDestination = form?.formTransport?.firstDestination;
        switch(form.payload[0]?.transfers?.dropoffLocation?.type) {
          case 'hotel':
            return `${formTransportDestination?.name || formTransportDestination?.hotel_name} (${formTransportDestination?.iata || formTransportDestination?.destination_code})`;
          case 'airport':
            return `${formTransportDestination?.name} (${formTransportDestination?.iata})`;
          case 'destination':
            return `${formTransportDestination?.city_name} (${formTransportDestination?.country_code})`;
          case 'city':
            return  `${formTransportDestination?.city_name} (${formTransportDestination?.country_code})`;
        }
    }
  }

      getTypeWay(typeWay: any): string {

    if(typeWay !== undefined) {
      return typeWay === 1 ? 'IDA' : 'VUELTA';
    } else {
      return '  ';
    }
  }

  getMessageFirstTime(input: string, pickup: any): string {

  let firstOrigin = {};

  firstOrigin = input === 'origin' ? pickup : {};

  let message = '';
  let messageFly = '';
  messageFly = pickup?.originDateTransfers === 'fly' ? 'Arribo del vuelo' : 'Hora del pickup';
  const messageDestination = 'Hora Pick up del hotel';

  if(firstOrigin && firstOrigin['type']) {
    message = firstOrigin['type'] === 'airport' ? messageFly : messageDestination;
  }




  return message;

  }

  /**
   * true si el producto es de origen Web o de una cotización offline.
   * Los ítems offline (`source === 'Web Offline Request'`) son cotizados a mano
   * por un operador, pero forman parte del itinerario y el agente debe poder
   * operarlos igual que a los cotizados en web.
   */
  isWebSource(source: string | undefined | null): boolean {
    return isWebSource(source);
  }

  /**
   * Un producto se puede "cancelar reserva" sólo si tiene reserva real contra
   * el proveedor (localizador). Los ítems offline cotizados a mano todavía no
   * reservados no lo tienen: para ésos la operación que corresponde es eliminar
   * el producto del itinerario, no cancelar.
   */
  canCancelReservation(item: any = this.item): boolean {
    if (!this.isWebSource(item?.source)) {
      return false;
    }
    const locator = item?.resultReserve?.providerReservationId
      || item?.resultReserve?.reservation?.providerReservationId;
    return !!locator;
  }

validDateUpdate(date: Date): boolean {
    const currentDate = new Date();
    const itemDate = new Date(date);

    // Usar UTC para evitar problemas de zona horaria
    const currentUTC = Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const itemUTC = Date.UTC(itemDate.getFullYear(), itemDate.getMonth(), itemDate.getDate());

    // Calcular diferencia en días
    const diffDays = (itemUTC - currentUTC) / (1000 * 60 * 60 * 24);

    return diffDays >= 1;
}

getAlertFilter(item: any): string {
  if (!item) {
return '';
}

  // Crear una key única basada en el item y su estado
  const cacheKey = this.getFilterCacheKey(item);
  // Si ya tenemos el filtro en caché, devolverlo
  if (this.filterCache.has(cacheKey)) {
    return this.filterCache.get(cacheKey) || '';
  }

  const color = '#d60159';
  const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });
  const tempFilterStr = Object.keys(tempFilterObj)
    .map(key => `${key}(${tempFilterObj[key]})`)
    .join(' ');

  const colorRegex = /color\((.*)\)/;
  const colorMatch = tempFilterStr.match(colorRegex);
  const filter = colorMatch ? colorMatch[1] : '';

  // Guardar en caché
  this.filterCache.set(cacheKey, filter);

  return filter;
}

private getFilterCacheKey(item: any): string {
  // Crear key basada en propiedades relevantes
  return `${item?.item?.syncProduct?.priceNonAvailable}_${item?.item?.syncProduct?.nonAvailable}_${item?.item?.status_id}`;
}


showExceptionsTooltip(event: MouseEvent, exceptions: any[], itemId: string) {
  if (this.disabledButtons[itemId]) {
return;
}

  this.disabledButtons[itemId] = true;

  const existingTooltip = document.getElementById(`exception-tooltip-${itemId}`);
  if (existingTooltip) {
existingTooltip.remove();
}

  const tooltip = document.createElement('div');
  tooltip.className = 'custom-exception-tooltip';
  tooltip.innerHTML = this.formatExceptionsTable(exceptions, itemId);
  tooltip.id = `exception-tooltip-${itemId}`;
  tooltip.style.position = 'absolute';
  tooltip.style.visibility = 'hidden';
  tooltip.style.zIndex = '1';
  document.body.appendChild(tooltip);

  // Solo botón X, sin closeOnOutsideClick
  const closeBtn = tooltip.querySelector('.close-tooltip-btn');
  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.hideExceptionsTooltip(itemId);
    });
  }

  // Botones de copiar
  const copyBtns = tooltip.querySelectorAll('.copy-tooltip-btn');
  copyBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const value = btn.getAttribute('data-copy-value');
      this.copyToClipboard(value || '');
    });
  });

  // Posicionar tooltip
  const tooltipHeight = tooltip.offsetHeight;
  const tooltipWidth = tooltip.offsetWidth;
  const scrollX = window.pageXOffset || document.documentElement.scrollLeft;
  const scrollY = window.pageYOffset || document.documentElement.scrollTop;

  let left = event.clientX + scrollX + 10;
  let top = event.clientY + scrollY - tooltipHeight - 150;

  if (top < scrollY) {
top = event.clientY + scrollY + 20;
}
  if (left + tooltipWidth > window.innerWidth + scrollX) {
    left = event.clientX + scrollX - tooltipWidth - 10;
  }

  tooltip.style.visibility = 'visible';
  tooltip.style.left = left + 'px';
  tooltip.style.top = top + 'px';
}

hideExceptionsTooltip(itemId: string) {
  const tooltip = document.getElementById(`exception-tooltip-${itemId}`);
  if (tooltip) {
tooltip.remove();
}

  delete this.disabledButtons[itemId];
  this.disabledButtonsArray = this.disabledButtonsArray.filter(id => id !== itemId);
  this.cdr.detectChanges();
}

formatExceptionsTable(exceptions: any[], index: string): string {
  return `
    <div style="border: 1px solid #ddd; border-radius: 8px; padding: 15px; min-width: 480px; box-shadow: 0 5px 20px rgba(0,0,0,0.2); background: white;">
      <div class="d-flex justify-content-between align-items-center">
        <p style="font-family: 'Lato'; font-weight: 600; font-size: 12px; margin-bottom: 12px;">
          Historial de eventos y errores
        </p>
        <button class="close-tooltip-btn" style="background-color: transparent; border: 0; width: fit-content; font-size: 13px; font-weight: 600; cursor: pointer;" title="Cerrar">
          ✕
        </button>
      </div>

      <table style="width: 100%; border-collapse: collapse; border-spacing: 0;">
        <thead>
          <tr>
            <th style="padding:0 0 6px 0; text-align: left; font-family: 'Lato'; font-weight: 600; font-size: 10px; width: 180px">Mensaje de Error</th>
            <th style="padding:0 10px 6px 10px; text-align: left; font-family: 'Lato'; font-weight: 600; font-size: 10px; border-left: 1px solid #bfbfbf; border-right: 1px solid #bfbfbf;">Acción</th>
            <th style="padding:0 10px 6px 10px; text-align: left; font-family: 'Lato'; font-weight: 600; font-size: 10px; border-right: 1px solid #bfbfbf;">Código</th>
            <th style="padding:0 10px 6px 10px; text-align: left; font-family: 'Lato'; font-weight: 600; font-size: 10px;">Fecha</th>
            <th style="padding:0 10px 6px 10px; text-align: left; font-family: 'Lato'; font-weight: 600; font-size: 10px; border-left: 1px solid #bfbfbf; border-right: 1px solid #bfbfbf;">Hora</th>
            <th style="padding:0 10px 6px 10px; text-align: left; font-family: 'Lato'; font-weight: 600; font-size: 10px; border-right: 1px solid #bfbfbf;">Usuario</th>
            <th style="padding:0 0 6px 10px; text-align: left; font-family: 'Lato'; font-weight: 600; font-size: 10px;">Estado</th>
          </tr>
        </thead>
        <tbody>
          ${exceptions.map(ex => `
            <tr>
              <td style="padding: 0px 10px 0px 0px; font-family: 'Lato'; font-weight: 400; font-size: 10px; width: 180px">${this.escapeHtml(ex.message || 'N/A')}</td>
              <td style="padding: 0px 10px 0px 10px; font-family: 'Lato'; font-weight: 400; font-size: 10px; text-align: center; border-left: 1px solid #bfbfbf; border-right: 1px solid #bfbfbf;">${this.escapeHtml(ex.action || 'N/A')}</td>
              <td style="padding: 0px 10px 0px 10px; font-family: 'Lato'; font-weight: 400; font-size: 10px; text-align: center; border-right: 1px solid #bfbfbf;">
                ${this.escapeHtml(ex.transactional_code || 'N/A')}
                <i class="bi bi-clipboard-check copy-tooltip-btn" style="cursor: pointer; margin-left: 5px;" title="Copiar código" data-copy-value="${this.escapeHtml(ex.transactional_code || '')}"></i>
              </td>
              <td style="padding: 0px 10px 0px 10px; font-family: 'Lato'; font-weight: 400; font-size: 10px; text-align: center;">${this.escapeHtml(this.formatDate(ex.date) || 'N/A')}</td>
              <td style="padding: 0px 10px 0px 10px; font-family: 'Lato'; font-weight: 400; font-size: 10px; text-align: center; border-left: 1px solid #bfbfbf; border-right: 1px solid #bfbfbf;">${this.escapeHtml(ex.hour || 'N/A')}</td>
              <td style="padding: 0px 10px 0px 10px; font-family: 'Lato'; font-weight: 400; font-size: 10px; text-align: center; border-right: 1px solid #bfbfbf;">${this.escapeHtml(ex.user?.name || ex.user?.email || 'Sistema')}</td>
              <td style="padding: 0px 0px 0px 10px; font-family: 'Lato'; font-weight: 500; font-size: 9px; text-align: center;">
                <span class="px-2 py-1" style="background-color: ${this.safeColor(ex.status?.color)}; border-radius: 50rem; color: white; display: inline-block;" title="${this.escapeHtml(ex.status?.name || 'N/A')}">${this.escapeHtml(ex.status?.name || 'N/A')}</span>
              </td>
            </tr>
          `).join('')}
        </tbody>
      </table>
    </div>
  `;
}

// Función helper para escapar HTML (evita inyección). Escapa también comillas
// porque varios valores se interpolan dentro de atributos (title, data-copy-value).
private escapeHtml(value: unknown): string {
  if (value === null || value === undefined) {
    return '';
  }
  const map: { [key: string]: string } = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  return String(value).replace(/[&<>"']/g, (m) => map[m]);
}

// El color del estado se interpola en un atributo style: solo se aceptan hex (#rgb / #rrggbb).
private safeColor(color: unknown): string {
  return typeof color === 'string' && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(color) ? color : '#6c757d';
}

// Helper para formatear fecha si es necesario
private formatDate(date: string): string {
  if (!date) {
return 'N/A';
}
  // Si viene en formato YYYY-MM-DD, convertir a DD-MM-YYYY
  if (date.includes('-')) {
    const parts = date.split('-');
    if (parts.length === 3) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
  }
  return date;
}

openModalItem(item: any, action: string): void {
    let data: any;

    data = this.viewDetailProduct(item, action);
    openModalResult(
                  item,
                  data.payload,
                  false,
                  this.dialog,
                  false, // luego ver este
                  this.itinerary,
                  '', // luego ver este
                  data.tabActive,
                  data.category,
                  this.clientsSettingAppBooking,
                  this.currencyAgency,
                  this.currencies,
                  this.itineraryService,
                  action
                  );

}

viewDetailProduct(item, action): any {
  const data = {
    tabActive: '',
    payload: null,
    category: 0
  };

  switch(item.categoryName) {
    case 'PARKS':
    case 'HOTELS':
          data.tabActive = action === 'detail' ? 'info' : 'comments';
          data.payload = item.payloadUpdate;
          data.category = item.category_id;
    break;
    case 'RENT-A-CAR':
          data.tabActive = action === 'detail' ? 'INFO' : 'comments';
          data.payload = item.payloadUpdate.products[0];
          data.category = item.category_id;
    break;
    case 'TOURS':
          data.tabActive = action === 'detail' ? 'info' : 'comments';
          data.payload = item.payload[0];
          data.category = item.payload[0]?.categoriesId[0];
    break;
    case 'TRANSPORTS':
        data.tabActive = action === 'detail' ? 'info' : 'comments';
        data.payload = item.payload[0];
        data.category = item.payload[0]?.categoriesId[0];
    break;
    case 'INSURANCE':
      data.category = item.payload.categoriesId[0];
      data.payload = item.payload;
    break;
  }

  return data;
}

validCreateCommentProduct(item): boolean {

  // Verificar status_id
  if (item.status_id !== 2) {
    return false;
  }

  // Verificar que departureDate existe
  if (!item.departureDate) {
    return false;
  }

  // Obtener fecha actual (sin hora)
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Parsear departureDate
  const departureDate = new Date(item.departureDate);
  departureDate.setHours(0, 0, 0, 0);

  // Verificar que la fecha de salida sea pasada (menor a hoy)
  return departureDate < today;
}

getChildrenAge(item): string {

  if (!item?.payloadUpdate?.products[0].others?.hotels?.roomConfiguration[0]?.children || item.payloadUpdate?.products[0].others?.hotels?.roomConfiguration[0]?.children.length === 0) {
    return '';
  }

  const ages = item?.payloadUpdate?.products[0].others?.hotels?.roomConfiguration[0]?.children.join(', ');
  const hasMultiple = item?.payloadUpdate?.products[0].others?.hotels?.roomConfiguration[0]?.children.length > 1;

  return `(${ages} ${hasMultiple ? 'años' : 'años'})`;
}

getAgesInItem(item: any): string {
  const expectedAges = this.getItemExpectedAges(item);

  if (!expectedAges || expectedAges.length === 0) {
    return '';
  }

  // Contar frecuencias de cada edad
  const ageCount: { [key: number]: number } = {};
  expectedAges.forEach(age => {
    ageCount[age] = (ageCount[age] || 0) + 1;
  });

  // Formatear el string
  const ageStrings: string[] = [];

  for (const [ageStr, count] of Object.entries(ageCount)) {
    const age = Number(ageStr); // ✅ Convertir a número

    if (count === 1) {
      ageStrings.push(`${age} año${age !== 1 ? 's' : ''}`);
    } else {
      ageStrings.push(`${count} de ${age} años`);
    }
  }

  // Unir con comas y "y"
  let result = '';
  if (ageStrings.length === 1) {
    result = ` (${ageStrings[0]})`;
  } else if (ageStrings.length === 2) {
    result = ` (${ageStrings[0]} y ${ageStrings[1]})`;
  } else {
    const last = ageStrings.pop();
    result = ` (${ageStrings.join(', ')} y ${last})`;
  }

  return result;
}

/**
 * Obtiene las edades esperadas para un item específico según su categoría
 */
getItemExpectedAges(item: any): number[] {
  const categoryId = item.category_id;
  let payloadUpdate;

  if (categoryId === 8) {
    payloadUpdate = item.payloadSync;
  } else {
    payloadUpdate = item.payloadUpdate;
  }

  if (!payloadUpdate) {
    return [];
  }

  let ages: number[] = [];

  switch (categoryId) {
    case 4: // PARQUES TEMATICOS (mismo formato que alojamiento)
    case 1: // HOTELES
      const roomConfigurations = payloadUpdate.products?.[0]?.others?.hotels?.roomConfiguration;
      if (roomConfigurations && Array.isArray(roomConfigurations)) {
        for (const room of roomConfigurations) {
          if (room.children && Array.isArray(room.children)) {
            ages.push(...room.children.map((age: any) => Number(age)));
          }
        }
      }
      break;

    case 2: // RENT A CAR
      const rentAcarChildren = payloadUpdate.childAge;
      if (rentAcarChildren && Array.isArray(rentAcarChildren)) {
        ages = rentAcarChildren.map((age: any) => Number(age));
      }
      break;

    case 6: // TOURS / EXPERIENCIAS
      const tourChildren = payloadUpdate.products?.[0]?.others?.tours?.children;
      if (tourChildren && Array.isArray(tourChildren)) {
        ages = tourChildren.map((age: any) => Number(age));
      }
      break;

    case 8: // TRANSPORTS / TRASLADOS
      const transferChildren = payloadUpdate.transfers.paxList.children;
      if (transferChildren && Array.isArray(transferChildren)) {
        ages = transferChildren.map((age: any) => Number(age));
      }
      break;

    case 9: // TICKETS
      const ticketChildren = payloadUpdate.products?.[0]?.others?.tours?.children;
      if (ticketChildren && Array.isArray(ticketChildren)) {
        ages = ticketChildren.map((age: any) => Number(age));
      }
      break;

    case 10: // ASISTENCIA / PAQUETES
      const assistanceChildren = payloadUpdate.products?.[0]?.insurances?.paxList?.paxAges?.filter((c: any) => c < 18) || [];
      if (assistanceChildren && Array.isArray(assistanceChildren)) {
        ages = assistanceChildren.map((age: any) => Number(age));
      }
      break;

    case 5: // VUELOS
      const flightChildren = item.childrenAges;
      if (flightChildren && Array.isArray(flightChildren)) {
        ages = flightChildren.map((age: any) => Number(age));
      }
      break;
  }

  return ages;
}


// Parques: tickets y plan de comidas de la tarifa (el modal los guarda en room.parkTicket y room.packageCode).
parkTicket(item: any): any {
  return parkTicketOf(item);
}

parkTicketTitle(item: any): string {
  return parkTicketTitle(item);
}

parkIncludesTicket(item: any): boolean {
  return parkIncludesTicket(item);
}

parkMeal(item: any): string {
  return parkMealOf(item);
}

getCategoryName(categoryName: string, item: any): string {

  if(!categoryName) {
    return 'No especificado';
  }

  switch(categoryName) {
    case 'PARKS': return 'Parque temático';
    case 'HOTELS': return 'Alojamiento';
    case 'RENT-A-CAR': return 'Rent a car';
    case 'FLIGHTS': return 'Vuelo';
    case 'TOURS':
      if(item.subCategoryId === 6) {
          return 'Experiencia';
      }
      if(item.subCategoryId === 9) {
        return 'Tickets';
      }
    case 'TRANSPORTS': return 'Traslado';
    case 'TICKET': return 'Tickets';
    case 'INSURANCE': return 'Asistencia';
    case 'BOATS': return 'Embarcación';
  }
}



itemCancellationPolicies(categoryName: string, item): any {

  switch(categoryName) {
    case 'PARKS':
    case 'HOTELS':
      return {
        rateClass: item?.room?.rateClass,
        cancellationPolicies: item?.room?.cancellationPolicy || [],
        currencyCancellation: item?.room?.cancellationPolicy && item?.room?.cancellationPolicy.length > 0 ? item?.room?.cancellationPolicy[0].currency : item?.room?.pricing?.currency,
        amount: item?.room?.cancellationPolicy?.find(c => c.amount > 0)?.amountProf || 0,
        from: item?.room?.cancellationPolicy?.find(c => c.amount > 0)?.from || 'N/A',
        cancellationFree: item?.room?.cancellationPolicy?.some(c => Number(c.amount) === 0),
        arrivalDate: item?.arrivalDate
      };
    case 'RENT-A-CAR':
      return {
        rateClass: item?.rateClass,
        cancellationPolicies: item.cancellationPolicies || [],
        currencyCancellation: item?.currency,
        amount: item.cancellationPolicies?.find(c => c.amount > 0)?.amountProf || 0,
        from: item.cancellationPolicies?.find(c => c.amount > 0)?.from || 'N/A',
        cancellationFree: item.cancellationPolicies?.some(c => Number(c.amount) === 0),
        arrivalDate: item?.arrivalDate
      };
    case 'TOURS':
       return {
        rateClass: item?.rateClassId,
        cancellationPolicies: item.cancellationPolicies?.cancellationPolicies || [],
        currencyCancellation: item?.currency,
        amount: item.cancellationPolicies?.cancellationPolicies?.find(c => c.amount > 0)?.amountProf || 0,
        from: item.cancellationPolicies?.cancellationPolicies?.find(c => c.amount > 0)?.dateFrom || 'N/A',
        cancellationFree: item.cancellationPolicies?.cancellationPolicies?.some(c => Number(c.amount) === 0),
        arrivalDate: item?.arrivalDate
      };
    case 'TRANSPORTS':
       return {
        rateClass: item?.pricing?.rateClass,
        cancellationPolicies: item.cancellationPolicies || [],
        currencyCancellation: item?.currency,
        amount: item.cancellationPolicies?.find(c => c.amount > 0)?.amountProf || 0,
        from: item.cancellationPolicies?.find(c => c.amount > 0)?.from || 'N/A',
        cancellationFree: item.cancellationPolicies?.some(c => Number(c.amount) === 0),
        arrivalDate: item?.arrivalDate
      };
    case 'INSURANCE':
      // hasCancellation = item.cancellationPolicies || [];
       return {
        rateClass: item?.rateClass,
        cancellationPolicies: item.cancellationPolicies || [],
        currencyCancellation: item?.currency,
        amount: item.cancellationPolicies?.find(c => c.amount > 0)?.amountProf || 0,
        from: item.cancellationPolicies?.find(c => c.amount > 0)?.from || 'N/A',
        cancellationFree: item.cancellationPolicies?.some(c => Number(c.amount) === 0),
        arrivalDate: item?.arrivalDate
      };
    case 'FLIGHTS':
      return {
        rateClass: item?.rateClassId,
        cancellationPolicies: item.cancellationPolicies || [],
        currencyCancellation: item?.currency,
        amount: item.cancellationPolicies?.find(c => c.amount > 0)?.amountProf || 0,
        from: item.cancellationPolicies?.find(c => c.amount > 0)?.from || 'N/A',
        cancellationFree: item.cancellationPolicies?.some(c => Number(c.amount) === 0),
        arrivalDate: item?.arrivalDate
      };
    default:
  }

}

emitFlight(item): void {
  const initialState: ModalOptions = {
    initialState: {
      title: 'Emitir',
      message: '¿Está seguro que desea emitir el vuelo?',
      icon: 'assets/icons/itinerary-detail/04-01.svg'
    }
  };

  this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
  const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
    if (result) {
      this.confirmEmitFlight(item);
    }
    confirmSubscription.unsubscribe();
  });
}

// bookingId sale de resultReserve.booking.bookingId (id interno de la reserva
// ante el proveedor) y locatorId de resultReserve.providerReservationId (el
// mismo "Localizador" que ya se muestra en la card y se usa para cancelar).
// Tipo de pago y cuotas van fijos (CASH/1); el monto es el que paga el
// agente (netPriceAgent), igual criterio que summary-reservation.
private confirmEmitFlight(item: any): void {

  // if (this.disabledButtons[item.id]) {
  //   return;
  // }
  this.disabledButtons[item.id] = true;

  const payload = {

    providerId: item?.providerId,
    bookingId: item?.resultReserve?.booking?.bookingId,
    locatorId: item?.resultReserve?.providerReservationId,
    payment: {
      type: 'CASH',
      amount: item?.price?.total,
      currency: item?.currency,
      installments: 1
    }
  };

  this._restService.doPost('app', 'flights/emit', payload).subscribe({
    next: () => {
      delete this.disabledButtons[item.id];
      this.notificationService.success('El vuelo fue emitido con éxito');
      this.reloadItinerary.emit();
    },
    error: (error: HttpErrorResponse) => {
      delete this.disabledButtons[item.id];
      this.notificationService.error('Ocurrió un error al emitir el vuelo');
      console.log(error);
    }
  });
}

voidFlight(item): void {
  const initialState: ModalOptions = {
    initialState: {
      title: 'Void',
      message: '¿Está seguro que desea anular (void) la emisión del vuelo?',
      icon: 'assets/icons/itinerary-detail/04-01.svg'
    }
  };

  this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
  const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
    if (result) {
      this.confirmVoidFlight(item);
    }
    confirmSubscription.unsubscribe();
  });
}

// Una vez emitido, el vuelo tiene que pasar sí o sí por void antes de
// poder cancelarse: el backend expone esto en item.flightState
// (canEmit/canVoid/canCancel), ver *ngIf de los botones en el template.
private confirmVoidFlight(item: any): void {
  if (this.disabledButtons[item.id]) {
    return;
  }
  this.disabledButtons[item.id] = true;

  const payload = {
    productId: item?.id
  };

  this._restService.doPost('app', 'flights/void', payload).subscribe({
    next: () => {
      delete this.disabledButtons[item.id];
      this.notificationService.success('El vuelo fue anulado (void) con éxito');
      this.reloadItinerary.emit();
    },
    error: (error: HttpErrorResponse) => {
      delete this.disabledButtons[item.id];
      this.notificationService.error('Ocurrió un error al anular (void) el vuelo');
      console.log(error);
    }
  });
}


  bedImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyVpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAyIDc5LjE2NDM2MCwgMjAyMC8wMi8xMy0wMTowNzoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTAwNjc4MTYyQTM5MTFFRTgyQjg5M0EwRDZFMkIyMEEiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTAwNjc4MTUyQTM5MTFFRTgyQjg5M0EwRDZFMkIyMEEiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo0MTU1OUIzRjNCMzkxMUVDQkU0NEY1MzY3OThCOEVFQSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo0MTU1OUI0MDNCMzkxMUVDQkU0NEY1MzY3OThCOEVFQSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PirdYvwAAAVFSURBVHja7FpvaBxFFH97t7d3l7t4FkVqY4xajJiGVGlBjdTUGtIWUlApBRUVpBRqRVoQin6wUNAP9VOM1z/UgqBFKCb+QUqxWBG/aBvaappEWkJyufRabSXmLrnen70d39zNNnfpzu7O3V6C5V74scfOzJv5zc68ee9NJEII3A7igttEakRqRKokstFLSZLK0bUEsQ6xFtGCaEbUI0KIacQM4iJiCPEz4kfElGgnXONEC+ZDUNYj+hEpqk4AacQ3rL0kQsRwzBUQeQpxWnDwPJxBtC80ER8ijMg5REKHhtjP9FedSCPinMME5oPqb6omkUcRE1UmoWOSGQzHidyHiC4QCR1R1q9jRHwLsJx4OI+oc4rIJ4tEQsdBJ4g8yazJYhKh/XdUQoQeUr8tMgkdp62ISEabm7ko9MQ9YWaL3UoAwr1hePmlFyv2ld7e9R58diTMxs31IH7gWVUzp3GbVefrOrsMSVj5arRchy579+yGZU3NZs12CDuNzAHstvQSQ3feHNiZgfMQPvApTCemwe/1g8stw6pVj8Ob214Hr1eBK1evQc/Hh2AyFgOi5SCVycDypibYtXM7LF16D6SyWQgG682624i4C/GPiNO42c7afWHzqySRSJBY7ApZuXrNvHIXccl1pKf3cL7Olle24kJ259/P1ZHIa2/sIPF4nIyOjpGHHnnMqs8tvD3CW1rP2FnXbk/hgw6PXIKhP84VrR03/Uyg5dIwFp3Iv4pEJvR1VSgvTCP8dOpU/ov6A347XXaILq1WO1q/6++H7r+vQTQaBTUza1hnPJaEfb1HQQk9YFg+GbkIazs3gUY0GLs0aNUld1w8qxXBx/1WFmvnO3shEKiDnKpCfTAALtldcg7R36l0BjJZFfw+L3gVzy0HblbNwY1UGryyDF8ePQx/XjiLdXK8bmPYvkGECI3o7uBpa25dDe+/uxs2da+/aS55lqqgnuSPJaMqerk+jg/29cBHH+7hdT2L9YIiREx9+b6vv4euzo6qxN6apkEoFDKLRySRcyRux+xWQyzOoKRoFmXaTNvsbLJqRCwCu39FrdYoiwYNRUU/LpfDQw03sVxexsVwr9CDU9NMiYyKErnA0jqGkkqm4PMv+uDsyGUIBnygOUBGvZEBkr0KGzdsMKs2KEqE5p3e4jXy+hRoa2uBweERVKBRe1Q0s5rd3VDiIGpaCvzBJdCw7F6zRr+IEqHJswxCMSTiUWBqKg5j4xHweb0lSSkyZ1N5u3mOBqtHH7LHBQ8vb4QsLleOZBEnRYnQDOBxxPNGhR7FB8f6jsHJ41+xgaHNkFz5p0Sf1P/Bv7wFknAuXApIspJ3Tei7QiCUA6Ki0cil0IlMg4KT09jYAK2tK3ljPcF1GE2IAMsxGRIZ+H0ELv91vTD/1Ky7MaynS4qkSz5G4XcmnwEjWaOv40F483WyagZmZmaAuDy88RwQztwViY0IUWJerVRG5IeesCSztpJVJrKimL3dXszOyEhKESkTFNctqc+N2dc4kUXZLzzDksuECK8OV+8hO1kUs5hdFxoo/Ipos2dV6bZzs5hDujXPTj1bohZgLfQ8e6LYNan0WsFmpnHezJfMttE7y0zjg9XI/bawnOxCpH9iiBVyw7O2c78iV2/DiKfN3ASHhC6ndiQxVLU7RFQeYdnHg2YJqHL9RsQRuiewn/GqX4ZiJ0nEdmYSBxwiQfV0oN6tVH/Z/n+Fd4hd7C4wI7gPaP1vWb6qovHaNb925W7EcyyVtILd6tK4P0BjMUTC4Fb3ulOBl1T7X5QakRqRGpH/lfwnwABexITqLQntGgAAAABJRU5ErkJggg==';
tourImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAyIDc5LjE2NDM2MCwgMjAyMC8wMi8xMy0wMTowNzoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjEgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjBDMzlFMDYyMkEzRDExRUVCRUUwQkIwMTE4NzQ4MzQwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjBDMzlFMDYzMkEzRDExRUVCRUUwQkIwMTE4NzQ4MzQwIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MEMzOUUwNjAyQTNEMTFFRUJFRTBCQjAxMTg3NDgzNDAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MEMzOUUwNjEyQTNEMTFFRUJFRTBCQjAxMTg3NDgzNDAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5kJJE5AAAEHUlEQVR42uxaS0tbQRQ+qRHfRBQUDUVU+tDQIBaLLbhqwU2pdVOUmoWuBJFYuxCX0ojL/gMXigoudSFi3SYq8UFqfCNoLQrWoFFUTHR6ZphIDDW5M7k3WsmBj3tzw50z38ycOY+5OkIIPAR5BA9E4kTiRDQSfegDnU53rzt82+akV1HHC8RbxBvEU8RjRDr/7wTxC7GGsCMmET9VZxgMQaEdbUe4aVOCcPN306Pp73W/JYnQmbQi/kgQCMUf3pY+1kSeIJwqEAiFk7cdEyLvEUcakAjAy3VoSuQzwqchiQCojgatiHxA+GNAIgA/16kqkWd8ykmM4eW6VSGilzXs2tpacnh4SFwuF+no6CDl5eWyG4BeDSJW2RFtbW0lwbK9vU0GBwdJXV0dycrKEmmrLVoi6aJ+IiUlhSQnJ5OkpCRitVrJv+T8/JwsLi6S7u5uYjablfqZ9GiItIuQ6OnpIU6nkzgcDmK328nW1ha5uroi4WRnZ0dp++2RiOhCl1NQ0EhDiFKlrv7s7AxwNti9z+eD9fV12NzchIODAzg5OQEkxf5LTU1l14qKCjCZTKDXK3LoSwiTTNBoFiFB5fLy8sZ9ZmYmGI1GSEhIgIuLC8DRh+XlZRgdHQVcXlBfXw/9/f1Kmy/lfXKJBo1tosbt9XpJJMGZIU1NTde7GhIU0fEl3NK6LbGq1CKXSEtLg9zcXHafmJgo+nqlTIZYolVi5Pf7ZV99LkPEeA+TQ6MMkYxoNFLjHhgYALfbDaenp7CwsAAq1M8yYl58QA8OFosF+vr6YHp6GmpqahiZu6iiHMsWBWZmZqCzs5P9Hh8fh/z8fHY/NjYWbV+PZYj8FtWCYQnzFc3NzbC3t8eeYSgCu7u7UF1dfe0/JHYrRX26jciKjKauri6Yn5+/4RgpgcbGRuYcPR4Pc5CSsiJU1+IyhfgkooWGJS0tLVBVVQWrq6uwtrYGGxsbjJjNZoOhoSFGgs6KpEzJEJmUsZGysjKGgBwdHcH+/j6Lp0KXlEQhcFKGiIsHaqXRWKfBYGAI3ZoDQaaALIWNsyJsv70impSOcEFBAZSUlADmIiKG36toSaiRWCkVtCUWPNIrzRoVtH2gJLEKlwzQeq0N8V3JkA0PD7ORxjQWsrOzr3OTUJmYmGA+hc7G3Nyckqa/8b6EXxFhEquADdHd4mXEGioaNHV+OTk5LMLNy8uDoqIiKCwshOLiYnalSRXNQ0ZGRpQuKbqXv+LlobDV+PtcDjpWsxz0oAp0AWmIERmqw6J1Efsjn3Itl1NtrI4V6GnUrAYkZnnbd3LQ41GBgOeuDnpuRCGIrzyEECWwxN81qHH0FsmPiB6GvkO8DjoMzQhKigKHoQ7ED9nD0NsGW00iMRHFlcb/9SOb+CcccSJxIuHlrwADAFIyAvDwTbhaAAAAAElFTkSuQmCC';
rentCarImage = ' data:image/png;base64,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';
}
